import { read } from "./read"
import { write } from "./write"

export const userAccount = {
  read,
  write,
}
